import { useCallback, useState } from "react"

import { hasLength, matches, useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../hooks/useCloudFunction"
import { AuthCreateData } from "../../../functions/auth/auth-create"
import { firebase } from "../../../services/firebase/firebase"
import { useLanguage } from "../../../contexts/language-context"
import { useAuth } from "../../../contexts/authentication-context"
import email from "../../../assets/regex/email"
import phone from "../../../assets/regex/phone"
import { useUsers } from "../../../contexts/users-context"

export default () => {
    const { L } = useLanguage()
    const { user } = useAuth()
    const { update } = useUsers()
    const [password, setPassword] = useState<string>()
    const { onStart, onSuccess, onError, processing } = useCloudFunction("auth-create")
    const form = useForm({
        initialValues: {
            email: "",
            name: "",
            phone: "",
            fullAccess: true,
            groups: [],
        },
        validate: {
            email: matches(email, L("Must be a valid email address")),
            name: hasLength({ min: 2 }, L("Must be at least %s characters long", 2)),
            phone: value => (value && !phone.test(value) ? L("Must be a valid phone number") : null),
        },
    })

    const onSubmit = useCallback(
        (values: typeof form.values) => {
            if (user) {
                onStart(L("Creating user..."))
                httpsCallable<AuthCreateData, string>(
                    firebase.functions,
                    "auth-create",
                )({
                    organisation: user.organisation,
                    email: values.email,
                    name: values.name,
                    phone: values.phone,
                    groups: values.fullAccess || values.groups,
                })
                    .then(result => setPassword(result.data))
                    .then(update)
                    .then(onSuccess(L("User created successfully!")))
                    .catch(onError(L("Creating user failed!")))
            }
        },
        [L, form, update, user],
    )

    return { form, onSubmit, processing, password }
}
